import getOnlineStoreLimit from './online-store-limit';
import getStoreId from './store-id';

export default {
  getOnlineStoreLimit,
  getStoreId,
};
